import { Component, EventEmitter, Input, Output, output, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../../shared/services/modal.service';

import { OverlayModule } from '@angular/cdk/overlay';
import { WidgetEdit } from '../../../../shared/components/widget-edit/widget-edit';

@Component({
  selector: 'app-ai-advice-widget',
  standalone: true,
  imports: [CommonModule, WidgetEdit, OverlayModule],
  templateUrl: './ai-advice-widget.html',
  styleUrl: './ai-advice-widget.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AiAdviceWidgetComponent {
  @Input() title = 'AI Advice';
  @Input() isEditMode: boolean = false;/*14-12-2025*/
  @Input() isAddMode: boolean = false;
  @Output() addWidget = new EventEmitter<void>();
  @Input() aiName: string = 'Charles';
  @Input() message: string = 'Consider pausing Disney+';
  @Input() savingAmount: string = '₹799/mo';
  @Input() size: 'small' | 'medium' | 'half' | 'full' = 'small';

  @Input() index = 0;
  @Input() activeDropdownIndex: number | null = null;
  @Input() getAvailableSizes!: (index: number) => Array<{ value: string; label: string }>;
  @Input() toggleSizeDropdown!: (index: number, event: Event) => void;
  @Input() changeWidgetSize!: (index: number, size: any) => void;
  @Input() removeWidget!: (index: number) => void;

  constructor(private modalService: ModalService) { }

  openAiAdviceModal() {
    if (this.isEditMode || this.isAddMode) return;
    this.modalService.openAiAdviceModal();
  }

}
